<!-- Separator.svelte -->
<script>
  export let customClass = "";
</script>

<div class="separator {customClass}"></div>
